import { NavLink } from 'react-router-dom';
import React from 'react';

import MapLink from '../../../doctorPage/common/Doctor/mapLink';
import { useUrlParser } from '../../../../utils/useUrlParser';

// Phone number formatting utility function
const formatPhoneNumber = (phoneNumber) => {
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // Format based on common Ukrainian phone patterns
  if (digits.length === 10) {
    // Format as: 0XX XXX XX XX
    return digits.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2-$3-$4');
  } else if (digits.length === 12 && digits.startsWith('380')) {
    // Format as: +38 0XX XXX XX XX
    return digits.replace(/^(380)(\d{2})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5');
  } else if (digits.length === 9) {
    // Format as: 0XX XXX XX XX (assuming missing leading 0)
    return digits.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '(0$1) $2-$3-$4');
  }
  
  // Return original if no pattern matches
  return phoneNumber;
};

export default function Job({
  doctor,
  division,
  id,
  institution,
  position,
  selectedJobId,
  setSelectedJobId,
  city,
  cabinet_num,
}) {
  const urlParser = useUrlParser();
  const isScreening = urlParser.urlData.params?.screening_40_plus === 'true';
  const isSelected = selectedJobId === id;
  
  const handleCardClick = () => {
    setSelectedJobId(id);
  };

  return (
    <div 
      className={`medic-feature-profile-information__place-service ${isSelected ? 'active' : ''}`} 
      key={id}
      onClick={handleCardClick}
    >
      {isSelected ? (
        // Expanded view - shows all details
        <>
          {!isScreening && (
            <div className="medic-feature-profile-information__place-service-position">{position.name}</div>
          )}
          <p className="medic-feature-profile-information__place-service-space mb-0">{institution.name}</p>
          <p className="medic-feature-profile-information__place-service-title">{institution.full_name}</p>
          <div className="medic-feature-profile-information__place-service-title">
            <NavLink to={`/city/${division.city_id}/hospitals/${institution.id}?division_id=${division.id}`}>
              <i className="fas fa-hospital" />
              {division.full_name}
            </NavLink>
          </div>

          <MapLink
            doctorId={doctor?.id}
            division={division}
            className="medic-feature-profile-information__place-service-address"
            mapUrl={
              division.address.lat && division.address.lon
                ? `https://maps.google.com/maps/place/${division.address.lat},${division.address.lon}`
                : null
            }
            externalMapUrl
          />
          {cabinet_num && (
            <div className="medic-feature-profile-information__place-service-address">
              <i className="fas fa-door-open" />
              Кабінет: {cabinet_num}
            </div>
          )}
          {!!division?.contacts?.length && (
            <div className="institution-info__indicator-item">
              <div className="medic-feature-profile-information__place-service-title mb-1">Телефон реєстратури</div>
                {division.contacts.map((phone, index) => (
                  <div key={`${index}_${phone}`} className='medic-feature-profile-information__place-service-address mb-1' onClick={(e) => { window.location = `tel:${phone.value.replace(/\D/g, '')}`; e.stopPropagation(); }}>
                    <i className="fas fa-phone-alt" />
                    {formatPhoneNumber(phone.value)}
                  </div>
                ))}
          </div>
        )}
        </>
      ) : (
        // Compact view - shows only position and institution name
        <>
          {!isScreening && (
            <div className="medic-feature-profile-information__place-service-position">{position.name}</div>
          )}
          <p className="medic-feature-profile-information__place-service-space mb-0">{institution.name}</p>
        </>
      )}
    </div>
  );
}
